module.exports = __webpack_public_path__ + "static/media/partners@2x.d9f0750b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/partners@2x.png
// module id = 607
// module chunks = 9